// extracted by mini-css-extract-plugin
module.exports = {"meta-data-rect":"NiPwe","metaDataRect":"NiPwe"};